import { render, staticRenderFns } from "./UserFormItem.vue?vue&type=template&id=086399cd&"
import script from "./UserFormItem.vue?vue&type=script&lang=js&"
export * from "./UserFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('086399cd')) {
      api.createRecord('086399cd', component.options)
    } else {
      api.reload('086399cd', component.options)
    }
    module.hot.accept("./UserFormItem.vue?vue&type=template&id=086399cd&", function () {
      api.rerender('086399cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/UserFormItem.vue"
export default component.exports